module.exports = __webpack_public_path__ + "static/media/4_r_rastenia_87.97_45.09.b3b81842.png";